import app from 'redux/reducers/appReducer.js';
import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import crmAdwords from 'redux/reducers/crmAdwordsReducer.js';
import crmAnalytics from 'redux/reducers/crmAnalyticsReducer.js';
import crmEmail from 'redux/reducers/crmEmail.js';
import crmFacebookAds from 'redux/reducers/crmFacebookAdsReducer.js';
import crmInquiries from 'redux/reducers/crmInquiriesReducer.js';
import crmRankings from 'redux/reducers/crmRankingsReducer.js';
import crmSocial from 'redux/reducers/crmSocialReducer.js';
import currentServiceProvider from 'redux/reducers/currentServiceProviderReducer.js';
import inboxScreen from '../../screens/inbox/store/inboxScreenReducer.js';
import leadModal from 'screens/leadModal/redux/leadModalReducer.js';
import messages from 'redux/reducers/messagesReducer.js';
import pipelineScreen from 'screens/pipeline/redux/pipelineScreenReducer.js';
import publicReporting from 'redux/reducers/publicReportingReducer.js';
import reporting from 'redux/reducers/reportingReducer.js';
import settingsScreen from '../../screens/settings/redux/settingsScreenReducer.js';
import helpScreen from '../../screens/help/redux/helpScreenReducer.js';
import sites from 'redux/reducers/crmReportsReducer.js';
import todosScreen from '../../screens/todos/store/todosScreenReducer.js';
import ui from 'redux/reducers/uiReducer.js';
import user from 'redux/reducers/userReducer.js';
import video from 'redux/reducers/videoReducer.js';
import insightsReport from 'redux/reducers/insightsReducer.js';

const rootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    currentServiceProvider,
    app,
    ui,
    user,
    messages,
    video,
    crmAdwords,
    reporting,
    publicReporting,
    sites,
    crmAnalytics,
    crmInquiries,
    crmRankings,
    leadModal,
    inboxScreen,
    pipelineScreen,
    todosScreen,
    settingsScreen,
    helpScreen,
    crmSocial,
    crmEmail,
    crmFacebookAds,
    insightsReport,
  });

export default rootReducer;
